import { useState } from "react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Languages, Loader2 } from "lucide-react";
import { API } from "../App";
import axios from "axios";

export function BilingualInput({ label, value, valueEl, onChange, onChangeEl, placeholder, placeholderEl, required, type = "text", className = "", "data-testid": testId }) {
  const [translating, setTranslating] = useState(false);

  const handleTranslate = async () => {
    if (!value?.trim()) return;
    setTranslating(true);
    try {
      const res = await axios.post(`${API}/admin/translate`, { text: value, source_lang: "en", target_lang: "el" });
      if (res.data.translated) {
        onChangeEl({ target: { value: res.data.translated } });
      }
    } catch {}
    finally { setTranslating(false); }
  };

  return (
    <div className={className}>
      <Label>{label}</Label>
      <div className="grid grid-cols-2 gap-2 mt-1">
        <div className="relative">
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] text-muted-foreground font-medium bg-background px-1 pointer-events-none">EN</span>
          <Input type={type} value={value} onChange={onChange} placeholder={placeholder} required={required} className="pr-8" data-testid={testId} />
        </div>
        <div className="relative">
          <button type="button" onClick={handleTranslate} disabled={translating || !value?.trim()} className="absolute left-2 top-1/2 -translate-y-1/2 z-10 p-0.5 rounded hover:bg-muted disabled:opacity-30 transition-colors" title="Auto-translate to Greek">
            {translating ? <Loader2 className="h-3.5 w-3.5 animate-spin text-primary" /> : <Languages className="h-3.5 w-3.5 text-primary" />}
          </button>
          <Input type={type} value={valueEl} onChange={onChangeEl} placeholder={placeholderEl || placeholder} className="pl-8 pr-8" data-testid={testId ? `${testId}-el` : undefined} />
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] text-muted-foreground font-medium bg-background px-1 pointer-events-none">EL</span>
        </div>
      </div>
    </div>
  );
}

export function BilingualTextarea({ label, value, valueEl, onChange, onChangeEl, placeholder, placeholderEl, rows = 2, className = "", "data-testid": testId }) {
  const [translating, setTranslating] = useState(false);

  const handleTranslate = async () => {
    if (!value?.trim()) return;
    setTranslating(true);
    try {
      const res = await axios.post(`${API}/admin/translate`, { text: value, source_lang: "en", target_lang: "el" });
      if (res.data.translated) {
        onChangeEl({ target: { value: res.data.translated } });
      }
    } catch {}
    finally { setTranslating(false); }
  };

  return (
    <div className={className}>
      <Label>{label}</Label>
      <div className="grid grid-cols-2 gap-2 mt-1">
        <div className="relative">
          <span className="absolute right-2 top-2 text-[10px] text-muted-foreground font-medium bg-background px-1 pointer-events-none z-10">EN</span>
          <Textarea value={value} onChange={onChange} placeholder={placeholder} rows={rows} className="pr-8" data-testid={testId} />
        </div>
        <div className="relative">
          <button type="button" onClick={handleTranslate} disabled={translating || !value?.trim()} className="absolute left-2 top-2 z-10 p-0.5 rounded hover:bg-muted disabled:opacity-30 transition-colors" title="Auto-translate to Greek">
            {translating ? <Loader2 className="h-3.5 w-3.5 animate-spin text-primary" /> : <Languages className="h-3.5 w-3.5 text-primary" />}
          </button>
          <span className="absolute right-2 top-2 text-[10px] text-muted-foreground font-medium bg-background px-1 pointer-events-none z-10">EL</span>
          <Textarea value={valueEl} onChange={onChangeEl} placeholder={placeholderEl || placeholder} rows={rows} className="pl-8 pr-8" data-testid={testId ? `${testId}-el` : undefined} />
        </div>
      </div>
    </div>
  );
}
